import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgInstagram = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="Instagram_svg__a"
      width={40}
      height={40}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M0 0h40v40H0z"
      />
    </mask>
    <g mask="url(#Instagram_svg__a)">
      <path
        fill="#F170B8"
        d="M26.333 34H13.666A7.666 7.666 0 0 1 6 26.333V13.667A7.666 7.666 0 0 1 13.666 6h12.667A7.667 7.667 0 0 1 34 13.667v12.666A7.667 7.667 0 0 1 26.333 34"
      />
    </g>
    <mask
      id="Instagram_svg__b"
      width={40}
      height={40}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M0 0h40v40H0z"
      />
    </mask>
    <g mask="url(#Instagram_svg__b)">
      <path
        fill="#F8BADD"
        d="M20 25a5 5 0 1 0-.001-10.001A5 5 0 0 0 20 25m-7-5a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
      />
    </g>
    <mask
      id="Instagram_svg__c"
      width={40}
      height={40}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M0 0h40v40H0z"
      />
    </mask>
    <g mask="url(#Instagram_svg__c)">
      <path
        fill="#F8BADD"
        d="M26 12.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 26 12.5"
      />
    </g>
    <mask
      id="Instagram_svg__d"
      width={40}
      height={40}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M0 0h40v40H0z"
      />
    </mask>
    <g mask="url(#Instagram_svg__d)">
      <path
        stroke="#00215B"
        strokeMiterlimit={10}
        strokeWidth={1.333}
        d="M18 32h-4.333A7.666 7.666 0 0 1 6 24.333V11.667"
      />
    </g>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgInstagram);

export default ForwardRef;
